import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { SearchBar, SearchBarQuickFilter, ButtonIcon } from '../../ui/styled';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from '@mui/material/Tooltip';

const CommonSearch = (props) => {
  const { searchText, setSearchText } = props;

  const handleSearchText = useDebouncedCallback((e) => {
    setSearchText(e.target.value);
  }, 1500);

  return (
    <SearchBar>
      <Tooltip
        title='It searches across all the columns'
        placement='right'
        arrow
      >
        <SearchBarQuickFilter
          variant='standard'
          onChange={handleSearchText}
          placeholder='Search…'
          autoFocus={searchText ? true : false}
          defaultValue={searchText}
          InputProps={{
            startAdornment: <SearchIcon fontSize='small' />,
            endAdornment: (
              <ButtonIcon
                title='Clear'
                aria-label='Clear'
                size='small'
                onClick={() => setSearchText('')}
              >
                <ClearIcon fontSize='small' />
              </ButtonIcon>
            ),
          }}
        />
      </Tooltip>
    </SearchBar>
  );
};

export default CommonSearch;
